import { render, staticRenderFns } from "./deviceRecord.vue?vue&type=template&id=405b80ab&scoped=true"
import script from "./deviceRecord.vue?vue&type=script&lang=js"
export * from "./deviceRecord.vue?vue&type=script&lang=js"
import style0 from "./deviceRecord.vue?vue&type=style&index=0&id=405b80ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b80ab",
  null
  
)

export default component.exports